import {create} from "zustand";

export const usePreOrderStore = create((set) => ({
    // Модальное окно "узнать цену"
    preOrderModalState: {
        open: false,
        source: '',
    },

    openModal: (data) => set({preOrderModalState: {...data, open: true}}),

    closeModal: () => set((state) => ({
        preOrderModalState: {...state.preOrderModalState, open: false}
    })),
}));
